import { render } from "./WhoisModal.vue?vue&type=template&id=21595128&ts=true"
import script from "./WhoisModal.vue?vue&type=script&lang=ts"
export * from "./WhoisModal.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"client/components/WhoisModal.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "21595128"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('21595128', __exports__)) {
    api.reload('21595128', __exports__)
  }
  
  module.hot.accept("./WhoisModal.vue?vue&type=template&id=21595128&ts=true", () => {
    api.rerender('21595128', render)
  })

}


export default __exports__